import { connect } from 'react-redux';
import { actions } from '../../../redux/modules/periodos/periodos';
import Periodo from './PeriodosList';


const ms2p = (state) => {
  return {
    ...state.periodo,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Periodo);
